module.exports = __webpack_public_path__ + "img/plusheder.6d7799b0.svg";